export const palette = {
    primary: {
        main: '#d9262d',     // Vibrant red
        light: '#ff5e5a',    // Lighter red
        dark: '#9f0003',     // Darker red
        contrastText: '#ffffff',
    },
    secondary: {
        main: '#26a69a',     // Teal
        light: '#64d8cb',    // Light teal
        dark: '#00766c',     // Dark teal
        contrastText: '#ffffff',
    },
    error: {
        main: '#f44336',
    },
    warning: {
        main: '#ff9800',
    },
    info: {
        main: '#2196f3',
    },
    success: {
        main: '#4caf50',
    },
    background: {
        default: '#fff9f9',  // Very light red (5% opacity)
        paper: '#ffffff',
    },
    text: {
        primary: '#212121',
        secondary: '#757575',
    },
    custom: {
        lightBackground: '#fff0f0',  // 10% opacity of primary
    }
};